import { createRouter, createWebHistory } from 'vue-router';
import OrdersList from './components/OrdersList.vue';
import AnnualStatChart from './components/AnnualStatChart.vue';
import UserLogin from './components/UserLogin.vue';

const routes = [
  {
    path: '/login',
    name: 'login',
    component: UserLogin
  },
  {
    path: '/',
    name: 'home',
    component: OrdersList,
    props: true // Allow passing props to the component
  },
  {
    path: '/annual-stat-chart',
    name: 'annual-stat-chart',
    component: AnnualStatChart
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

// Navigation guard for authentication
router.beforeEach(async (to, from, next) => {
  if (to.path === '/login') {
    return next();
  }
  // Check session
  try {
    const res = await fetch('/api/session');
    if (res.ok) {
      const data = await res.json();
      to.meta.loggedIn = true;
      to.meta.userAuthority = data.authority;
      return next();
    } else {
      to.meta.loggedIn = false;
      to.meta.userAuthority = 2;
      return next('/login');
    }
  } catch (e) {
    to.meta.loggedIn = false;
    to.meta.userAuthority = 2;
    return next('/login');
  }
});

export default router;